import React from "react";
import classNames from "classnames";
import { SectionTilesProps } from "../../../utils/SectionProps";

const propTypes = {
  ...SectionTilesProps.types,
};

const defaultProps = {
  ...SectionTilesProps.defaults,
};
const ProjectDetailBottom = ({
  projectName,
  messageBlock1,
  messageBlock2,
  block1Img,
  block2Img,
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const outerClasses = classNames(
    "features-tiles section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "testimonial-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const tilesClasses = classNames("tiles-wrap");
  const imgOnTheRightSideClasses = classNames("row-content mb-48");
  const imgOnTheLeftSideClassesMdUp = classNames(
    "row-content show-content-md-up mb-48"
  );
  const imgOnTheLeftSideClassesSmDown = classNames(
    "row-content show-content-sm-down mb-48"
  );

  return (
    <section {...props} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <div className={tilesClasses}>
            {/* Row 1 - Img on the left */}
            {messageBlock1 && block1Img && (
              <div className={imgOnTheRightSideClasses}>
                <div
                  className="tiles-item-project-img-left reveal-from-right"
                  data-reveal-delay="200"
                >
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="h-content-for-w-img-500px">
                      <img
                        src={block1Img}
                        alt="Understanding"
                        className="w-img-500px"
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="tiles-item-project-text-right reveal-from-right"
                  data-reveal-delay="200"
                >
                  {messageBlock1}
                </div>
              </div>
            )}

            {/* Row 2 - Img on the right */}
            {messageBlock2 && block2Img && (
              <>
                <div className={imgOnTheLeftSideClassesMdUp}>
                  <div
                    className="tiles-item-project-text-left reveal-from-left"
                    data-reveal-delay="200"
                  >
                    {messageBlock2}
                  </div>
                  <div
                    className="tiles-item-project-img-right reveal-from-left"
                    data-reveal-delay="200"
                  >
                    <div className="d-flex flex-column align-items-center justify-content-center">
                      <div className="h-content-for-w-img-500px">
                        <img
                          src={block2Img}
                          alt="Ideas with Design and Concept"
                          className="w-img-300px"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={imgOnTheLeftSideClassesSmDown}>
                  <div
                    className="tiles-item-project-img-left reveal-from-right"
                    data-reveal-delay="200"
                  >
                    <div className="d-flex flex-column align-items-center justify-content-center">
                      <div className="h-content-for-w-img-300px">
                        <img
                          src={block2Img}
                          alt="Ideas with Design and Concept"
                          className="w-img-300px"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="tiles-item-project-text-right reveal-from-right"
                    data-reveal-delay="200"
                  >
                    {messageBlock2}
                  </div>
                </div>
              </>
            )}

            {/* Row 3 - Two Img on left and right */}
            {!messageBlock1 && !messageBlock2 && block1Img && block2Img && (
              <div className={imgOnTheRightSideClasses}>
                <div
                  className="tiles-item-project-img-left reveal-from-right"
                  data-reveal-delay="200"
                >
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="h-content-for-w-img-500px">
                      <img
                        src={block1Img}
                        alt="Understanding"
                        className="w-img-500px"
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="tiles-item-project-img-right reveal-from-left"
                  data-reveal-delay="200"
                >
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="h-content-for-w-img-500px">
                      <img
                        src={block2Img}
                        alt="Ideas with Design and Concept"
                        className="w-img-500px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

ProjectDetailBottom.propTypes = propTypes;
ProjectDetailBottom.defaultProps = defaultProps;

export default ProjectDetailBottom;
